import React from "react";
import { Box } from "@mui/material";
import { getPageShellSx } from "../cmms/assetHierarchyStyles";
import SparePartsPanel from "./components/SparePartsPanel";

/*
 * The maintenance store page.
 *
 * What is held, what is on the shelf, and how the number got there. The balance is not a column
 * on the register: it is the sum of the movements booked here less what work orders have used,
 * which is why a movement and a work order booking both change the same number and neither one
 * has to remember to tell the other.
 */
export default function CmmsSpareParts() {
  return (
    <Box sx={getPageShellSx()}>
      <SparePartsPanel />
    </Box>
  );
}
